<template>
    <li class="shortlist-listing-card">
        <div class="inner">
            <div class="flip-card-inner" :class="{ flipped: showCardBack }">
                <div class="flip-card-front">
                    <div class="close-btn" v-if="!publicView && !shortlist.public">
                        <button
                            type="button"
                            class="circled interactive grey close-modal outline"
                            @click.stop.prevent="showRemoveConfirm"
                        >
                            <svg-icon id="cross"></svg-icon>
                        </button>
                    </div>
                    <div
                        class="flex flex-col h-full"
                    >
                        <div class="image">
                            <vueper-slides
                                :bullets="false"
                                :slide-ratio="2 / 3"
                                :init-slide="listing.pivot.media_id ? listing.media.findIndex(function(e) { return e.id === listing.pivot.media_id}) + 1 : 1"
                                :touchable="false"
                            >
                                <template #arrow-left>
                                    <svg xmlns="http://www.w3.org/2000/svg">
                                        <image xlink:href="/images/icons/chevron-left-white.svg" />
                                    </svg>
                                </template>
                                <template #arrow-right>
                                    <svg xmlns="http://www.w3.org/2000/svg">
                                        <image xlink:href="/images/icons/chevron-right-white.svg" />
                                    </svg>
                                </template>
                                <img
                                    v-if="!listing.media.length"
                                    :src="listing.preferred_thumbnail ? listing.preferred_thumbnail.url : listing.thumbnail_url"
                                    class="cover"
                                    :alt="listing.space_name"
                                />
                                <vueper-slide
                                    v-for="(image, i) in listing.media"
                                    v-if="image.collection_name != 'floor_plans'"
                                    :key="listing.id + '-' + i"
                                    :image="image.urls.thumbnail_large"
                                >
                                    <template #content v-if="!publicView && !shortlist.public && listing.media.length > 1">
                                        <button
                                            v-if="image.id === listing.pivot.media_id"
                                            class="btn-select-cover selected"
                                        >
                                            SELECTED
                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                <image xlink:href="/images/icons/check-icon-white.svg" />
                                            </svg>
                                        </button>
                                        <button
                                            v-else
                                            class="btn-select-cover" @click="setDefaultImage(image.id)"
                                        >
                                            MAKE COVER
                                        </button>
                                    </template>
                                </vueper-slide>
                            </vueper-slides>
                        </div>
                        <div class="description">
                            <h4
                                class="wt-std location"
                                v-if="listing.address_label"
                            >
                                <div class="address-label">{{ listing.address_label }}</div>
                            </h4>
                            <h3 class="title font-castoro">
                                <span>
                                    {{ listing.space_name }}
                                </span>
                            </h3>
                            <div class="flex price__wrap">
                                <h4
                                    class="wt-md fg-dark font-base price"
                                    v-if="listing.rate_day && !listing.price_on_application"
                                >
                                    From {{listing.rate_day_formatted_including_booking_fee}} per day
                                </h4>
                                <h4 class="wt-md fg-dark font-base price" v-else>
                                    Price on application
                                </h4>
                            </div>
                        </div>

                        <div class="actions">
                            <div class="book-btn button outline-black" @click.stop.prevent="showBooking">Quote/Recce</div>
                            <a :href="`/location-hire/${listing.address.state.slug.toLowerCase()}/${listing.slug}`" class="view-listing-btn" target="_blank">
                                View Listing
                            </a>
                        </div>
                    </div>
                </div>
                <div class="flip-card-back" @click.stop.prevent>
                    <!-- Flip Card Back -->
                    <div class="bookings-back" v-if="bookingCardBack">
                        <div class="close-btn">
                            <button
                                type="button"
                                class="circled interactive grey close-modal outline"
                                @click.stop.prevent="showCardFront"
                            >
                                <svg-icon id="cross"></svg-icon>
                            </button>
                        </div>
                        <div class="bookings-back-content">
                            <div class="booking-heading">Make a Booking for:</div>
                            <div class="booking-listing-name">{{ listing.space_name }}</div>
                            <div class="booking-actions">
                                <book-button :listing="listing" type="booking" class="book-location-container"></book-button>
                                <book-button :listing="listing" type="recce" class="book-recce-container"></book-button>
                                <div class="view-bookings-btn button-slide-hover" @click="goToBookings" v-if="!publicView">View my bookings</div>
                            </div>
                        </div>
                    </div>
                    <div class="remove-confirm" v-if="removeCardBack">
                        <div class="remove-confirm-heading">Are you sure you want to remove from your shortlist?</div>
                        <div class="remove-confirm-actions">
                            <div @click="removeListing(listing)">Yes</div>
                            <div @click="showCardFront">Cancel</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import BookButton from "../../../../listings/bookings/BookButton.vue";

export default {
    components: {
        BookButton
    },
    props: {
        listing: {
            type: Object,
            required: true,
        },
        shortlist: {
            type: Object,
            required: true,
        },
        removeListing: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            showCardBack: false,
            removeCardBack: false,
            bookingCardBack: false
        };
    },
    computed: {
        publicView() {
            return this.$store.getters['findspace/public']
        },
    },
    methods: {
        setDefaultImage(media_id) {
          axios.put(`/api/account/shortlists/${this.shortlist.id}/listings/${this.listing.id}/pivot`, { media_id })
            .then(() => {
              this.listing.pivot.media_id = media_id;
              this.$toasted.show(`Your listing image has been updated.`, {
                type: 'success'
              })
            })
            .catch(() => {
              this.$toasted.show('Your listing image could not be updated, please try again.', {
                type: 'error'
              })
            })
            .then(() => {})
        },
        showRemoveConfirm() {
            this.removeCardBack = true;
            this.showCardBack = true;
        },
        showBooking() {
            this.bookingCardBack = true;
            this.showCardBack = true;
        },
        showCardFront() {
            this.showCardBack = false;
            this.removeCardBack = false;
            this.bookingCardBack = false;
        },
        closeModal() {
            this.$emit('closeModal');
        },
        goToBookings() {
            this.$store.commit('findspace/navigateToSubpage', { page: 'bookings', subpage: 'home' })
            this.closeModal();
        },
    },
};
</script>
